<template>
  <div class="content if-profile">
    <div class="md-layout profit-loss">
      <SPIFProfileHeader  :headerData="this.headerData"/>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4"
      >
        <h1 class="section_header">Balance Sheet</h1>
        <!-- <h1 class="md-subheading profile-title">Balance Sheet</h1> -->
        <div
          class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0 mt-4"
        >
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab
                  v-if="this.display_by_variance"
                  id="tab-Charts"
                  md-label="Variance"
                  md-icon="pie_chart"
                  class="p-0"
                >
                  <div class="md-layout">
                    <div class="md-layout-item p-0">
                      <md-card-header class="md-card-header-icon">
                        Varience
                      </md-card-header>
                      <md-card-content>
                        <div class="md-layout px-4">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100"
                          >
                            <md-card class="md-card-profile">
                              <md-card-header class="md-card-header-icon">
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >
                                    Variance from Industry
                                  </div>
                                </h4>
                                <!-- <h4 class="title text-left">
                                  Variance from Industry
                                </h4> -->
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  >
                                    <md-table
                                      v-model="tableDataVarianceDollar"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell
                                          class="md-table-side-label"
                                        >
                                          {{ item.name }}
                                          <md-tooltip md-direction="bottom">{{
                                            item.rollover
                                          }}</md-tooltip>
                                        </md-table-cell>
                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >{{ item.dates[key] }}
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                          <div
                            v-for="(chart, i) in charts"
                            :key="i"
                            class="md-layout-item md-medium-size-100 md-size-50"
                          >
                            <md-card class="md-card-profile">
                              <md-card-content>
                                <chart-card
                                  header-animation="false"
                                  :chart-data="chart.data"
                                  :chart-options="getOptions(chart.options)"
                                  chart-type="Pie"
                                  header-icon
                                  chart-inside-content
                                  background-color="blue"
                                >
                                  <template slot="chartInsideHeader">
                                    <h4 class="title m-0">
                                      <div
                                        class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                      >
                                        {{ chart.title }}
                                      </div>
                                    </h4>
                                    <!-- <h4 class="title">{{ chart.title }}</h4> -->
                                  </template>
                                  <template slot="footer">
                                    <div class="md-layout">
                                      <div class="md-layout-item md-size-100">
                                        <p class="common_footer black-color">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                                      </div>
                                      <div class="md-layout-item">
                                        <span
                                          v-for="(v, i) in chart.options
                                            .legendNames"
                                          :key="i"
                                          :class="`ct-series-${i}`"
                                        >
                                          <i class="fa fa-circle"></i>
                                          {{ v }} ({{
                                            chart.options.labelInterpolationSignFn(
                                              chart.data.series[i]
                                            )
                                          }})
                                        </span>
                                      </div>
                                    </div>
                                  </template>
                                </chart-card>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-card-content>
                    </div>
                  </div>
                </md-tab>
                <md-tab
                  v-if="this.display_by_dollars"
                  id="tab-payments"
                  md-label="Dollars"
                  md-icon="payments"
                  class="p-0"
                >
                  <div class="md-layout">
                    <div class="md-layout-item p-0">
                      <md-card-header class="md-card-header-icon">
                        Dollars
                      </md-card-header>
                      <md-card-content>
                        <div class="md-layout px-4">
                          <div class="md-layout-item">
                            <md-card class="md-card-profile">
                              <md-card-header class="md-card-header-icon">
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >
                                    Your Firm
                                  </div>
                                </h4>
                                <!-- <h4 class="title text-left">
                                  Your Firm
                                </h4> -->
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  >
                                    <md-table
                                      v-model="tableDataFirmDollar"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell
                                          class="md-table-side-label"
                                        >
                                          {{ item.name }}
                                          <md-tooltip md-direction="bottom">{{
                                            item.rollover
                                          }}</md-tooltip>
                                        </md-table-cell>
                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >{{ item.dates[key] }}
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                        <div class="md-layout px-4">
                          <div class="md-layout-item">
                            <md-card class="md-card-profile">
                              <md-card-header class="md-card-header-icon">
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >
                                    Industry
                                  </div>
                                </h4>
                                <!-- <h4 class="title text-left">
                                  Industry
                                </h4> -->
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  >
                                    <md-table
                                      v-model="tableDataIndustryDollar"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell
                                          class="md-table-side-label"
                                        >
                                          {{ item.name }}
                                          <md-tooltip md-direction="bottom">{{
                                            item.rollover
                                          }}</md-tooltip>
                                        </md-table-cell>
                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >{{ item.dates[key] }}
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-card-content>
                    </div>
                  </div>
                </md-tab>
                <md-tab
                  v-if="this.display_by_percentages"
                  id="tab-money"
                  md-label="Percentages"
                  md-icon="money"
                  class="p-0"
                >
                  <div class="md-layout">
                    <div class="md-layout-item p-0">
                      <md-card-header class="md-card-header-icon">
                        Percentages
                      </md-card-header>
                      <md-card-content>
                        <div class="md-layout px-4">
                          <div class="md-layout-item md-size-100">
                            <md-card class="md-card-profile">
                              <md-card-header class="md-card-header-icon">
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >
                                    Your Firm
                                  </div>
                                </h4>
                                <!-- <h4 class="title text-left">
                                  Your Firm
                                </h4> -->
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  >
                                    <md-table
                                      v-model="tableDataFirmPercent"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell
                                          class="md-table-side-label"
                                        >
                                          {{ item.name }}
                                          <md-tooltip md-direction="bottom">{{
                                            item.rollover
                                          }}</md-tooltip>
                                        </md-table-cell>
                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >{{ item.dates[key] }}
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                          <div class="md-layout-item md-size-100">
                            <md-card class="md-card-profile">
                              <md-card-header class="md-card-header-icon">
                                <h4 class="title m-0">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                  >
                                    Industry
                                  </div>
                                </h4>
                                <!-- <h4 class="title text-left">
                                  Industry
                                </h4> -->
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                  >
                                    <md-table
                                      v-model="tableDataIndustryPercent"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell
                                          class="md-table-side-label"
                                        >
                                          {{ item.name }}
                                          <md-tooltip md-direction="bottom">{{
                                            item.rollover
                                          }}</md-tooltip>
                                        </md-table-cell>
                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >{{ item.dates[key] }}
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-card-content>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import SPIFProfileHeader from './_partials/SPIFProfileHeader.vue';

export default {
  components: {
    SPIFProfileHeader,
    ChartCard,
    NavTabsCard,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      view: 'dollar',
      tableDataIndustryDollar: [],
      tableDataIndustryPercent: [],
      tableDataFirmDollar: [],
      tableDataFirmPercent: [],
      tableDataVarianceDollar: [],
      charts: [],
      options: {
        showLabel: false,
        legendNames: [],
        height: '250px',
      },
      display_by_dollars: false,
      display_by_percentages: false,
      display_by_variance: false,
    };
  },
  computed: {
    ...mapState({
      chartData: (state) => state.user.report.data.chartData['profitLoss'],
      table: (state) => state.user.report.data.tables['BS'],
      showYears: (state) => state.user.report.data.showYears,
      years: (state) => state.user.report.data.years,
      report: (state) => state.user.report.data,
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'dollar';
    }

    this.switchView(section);
    if (
      this.report.displaySettings.includes('pl_balance_percent') &&
      this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_dollars = true;
      this.display_by_percentages = true;
      this.display_by_variance = true;
    }
    if (
      this.report.displaySettings.includes('pl_balance_dollar') &&
      !this.report.displaySettings.includes('pl_balance_percent')
    ) {
      this.display_by_dollars = true;
      this.display_by_variance = true;
    }
    if (
      this.report.displaySettings.includes('pl_balance_percent') &&
      !this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_percentages = true;
      this.display_by_variance = true;
    }
    if (
      !this.report.displaySettings.includes('pl_balance_percent') &&
      !this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_dollars = false;
      this.display_by_percentages = false;
      this.display_by_variance = false;
    }
    let filtered_years = [];
    // this.showYears.forEach((s, i) => {
    //   if (s) {
    //     filtered_years.push(this.years[i]);
    //   }
    // });
    Object.keys(this.showYears).forEach((k, i) => {
      if (this.showYears[k]) {
        filtered_years.push(this.years[i]);
      }
    });
    if (!filtered_years.length) {
      filtered_years = this.years;
    }
    this.tableDataVarianceDollar = this.formatTable(
      this.table,
      'variance',
      'dollar'
    );
    this.tableDataVarianceDollar = this.tableDataVarianceDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
    this.tableDataIndustryDollar = this.formatTable(
      this.table,
      'industry',
      'dollar'
    );
    this.tableDataIndustryDollar = this.tableDataIndustryDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
    this.tableDataIndustryPercent = this.formatTable(
      this.table,
      'industry',
      'percent'
    );
    this.tableDataIndustryPercent = this.tableDataIndustryPercent.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
    );
    this.tableDataFirmDollar = this.formatTable(this.table, 'firm', 'dollar');
    this.tableDataFirmDollar = this.tableDataFirmDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
    this.tableDataFirmPercent = this.formatTable(this.table, 'firm', 'percent');
    this.tableDataFirmPercent = this.tableDataFirmPercent.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });
    this.charts = this.formatPieChart(this.chartData);
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'dollar';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function(type) {
      this.view = type;
    },
  },
};
</script>
<style lang="scss">
.profit-loss {
  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}

h4.main-street {
  padding-top: 0;
}
</style>
